export default {
  auditStateMap: {
    0: { title: '待审核' },
    1: { title: '审核通过' },
    2: { title: '审核不通过' },
    3: { title: '已删除' }
  },
  auditActionMap: {
    EDIT: { title: '编辑' },
    PASS: { title: '通过' },
    REFUSE: { title: '拒绝' },
    DELETE: { title: '删除' },
    VIEW: { title: '查看' }
  },
  tradeTypeMap: {
    1: {title: '转让'},
    2: {title: '求购'}
  }
}



// WEBPACK FOOTER //
// ./src/global/goodsConfig.js